export default '/build/8cb6d8f9.svg'